import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const CalendarIcon = React.memo(function CalendarIcon(props: TCalendarIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Calendar" {...props}>
            <path d="M19.625 3.3125H15.6875V1.8125C15.6875 1.70937 15.6031 1.625 15.5 1.625H14.1875C14.0844 1.625 14 1.70937 14 1.8125V3.3125H8V1.8125C8 1.70937 7.91563 1.625 7.8125 1.625H6.5C6.39687 1.625 6.3125 1.70937 6.3125 1.8125V3.3125H2.375C1.96016 3.3125 1.625 3.64766 1.625 4.0625V19.625C1.625 20.0398 1.96016 20.375 2.375 20.375H19.625C20.0398 20.375 20.375 20.0398 20.375 19.625V4.0625C20.375 3.64766 20.0398 3.3125 19.625 3.3125ZM18.6875 18.6875H3.3125V9.78125H18.6875V18.6875ZM3.3125 8.1875V5H6.3125V6.125C6.3125 6.22813 6.39687 6.3125 6.5 6.3125H7.8125C7.91563 6.3125 8 6.22813 8 6.125V5H14V6.125C14 6.22813 14.0844 6.3125 14.1875 6.3125H15.5C15.6031 6.3125 15.6875 6.22813 15.6875 6.125V5H18.6875V8.1875H3.3125Z" />
        </IconBase>
    );
});

export default CalendarIcon;

// #region Types

export type TCalendarIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CalendarIcon /> : { ...IconBaseExample, render: CalendarIcon };

// #endregion
